import { render, staticRenderFns } from "./NosologyItem.vue?vue&type=template&id=d58805d4&scoped=true"
import script from "./NosologyItem.vue?vue&type=script&lang=js"
export * from "./NosologyItem.vue?vue&type=script&lang=js"
import style0 from "./NosologyItem.vue?vue&type=style&index=0&id=d58805d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58805d4",
  null
  
)

export default component.exports